import { useTranslation } from 'react-i18next';
import * as Env from 'widget/env';

const useMsgPreview = (msg: Env.Message | undefined) => {
  const { t } = useTranslation();
  const plug = t`Sorry, this message is not supported in this version.`;

  if (!msg) return plug;
  else if (msg.type == 'file') return `📎 ${t`File`}`;
  else if (msg.type == 'message' || msg.type == 'reaction') return msg.content;

  return plug;
};

export default useMsgPreview;
